"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinPath = void 0;
/**
 * A non-native implementation of 'path' import utilities (needed instead of polyfill)
 *
 * @param parts Strings to join
 */
var joinPath = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    var separator = '/';
    var replace = new RegExp("".concat(separator, "{1,}"), 'g');
    var path = parts.join(separator).replace(replace, separator);
    return path.endsWith(separator) ? path.slice(0, path.length - 1) : path;
};
exports.joinPath = joinPath;
//# sourceMappingURL=common.js.map